import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from 'app/service/authentication.service';
import {KullaniciService} from 'app/service/kullanici.service';
import {Kullanici} from 'app/model/kullanici.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {

  reference: string;

  constructor(public authenticationService: AuthenticationService,
              public kullaniciService: KullaniciService, public router: Router) {
  }

  ngOnInit() {
    if (this.isSignedInAdmin()) {
      var kullaniciPk = JSON.parse(localStorage.getItem('currentUser')).kullaniciPk;
      var kullanici: Kullanici = null;
      this.reference = JSON.parse(localStorage.getItem('currentUser')).name;
    }

  }

  isSignedInAdmin(): boolean {
    return this.authenticationService.isSignedInAdmin();
  }

  public _extractBeginningPart(stringValue: string) {
    if (stringValue != null) {
      return stringValue.length > 10 ? stringValue.substring(0, 10) + '...' : stringValue;
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin-header/admin-header.component.ts